import $ from 'jquery';
import run from '../../utilities/run';
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import {setElementsFromScope, setOptionsForSelect} from "../../utilities/selectorHelpers";
const _ = require("underscore");
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";
import {isTruthy, isPresent} from '../../utilities/general';

export default function EbayConnectionsTab(wizard){

  const self = this;
  const el = wizard.getWizardElement();

  const retpartner=el.data("retailer-partners-info");
  const statusVal = el.data("status-val");
  const openEbayChannelBtn = el.find("#open-ebay-channel-button");
  const ebayUrl = el.data("ebay-url");
  const loadEbayChannel = el.find("#load-ebay-channel");
  const closedBeforeAuth = el.find(".closed-before-authorization");
  const connNotAuth = el.find(".conn-not-authorized");
  const connAuth = el.find(".conn-authorized");
  const connAuthDateTime = el.find("#conn-auth-time");
  let okayToClose = false;
  let connectionStatus = false;
  const submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();

  self.init = function(){
     onLoad();
  };

  self.didNavigateToForm = function(){
  };

  self.areInputsValidForForm = function(){
    return connectionStatus;
  }

  function onLoad(){
    closedBeforeAuth.hide();
    connNotAuth.hide();
    connAuth.hide();
    if(statusVal){
      connAuth.text(getConnAuthText(retpartner.connAuthDate, retpartner.connAuthTime));
      connAuth.show();
      openEbayChannelBtn.hide();
      connectionStatus =true;
    }
    if(isPresent(retpartner)) {
      connAuthDateTime.val(retpartner.connAuthDateTime);
    }
  }

  window.addEventListener("storage", function(event){
    connectionStatus = localStorage.getItem("connectionStatus");
    localStorage.removeItem("connectionStatus");
    okayToClose = true;
  }, true);

  openEbayChannelBtn.click(function(e){
    openEbayChannelBtn.hide();
    loadEbayChannel.show();
    const childWindow = window.open(ebayUrl, "_blank");
    let pollTimer = window.setInterval(function () {
      if (okayToClose) {
        childWindow.close();
      }
      if (isTruthy(childWindow.closed)) {
        window.clearInterval(pollTimer);
        onChildWindowClose(childWindow);
      }
    }, 200);
  });

  function onChildWindowClose(childWindow) {
    if (okayToClose) {
      if (isTruthy(connectionStatus)) {
        getAuthDateAndTime();
        loadEbayChannel.hide();
        connAuth.show();
      } else {
        openEbayChannelBtn.show();
        loadEbayChannel.hide();
        connNotAuth.show();
      }
    } else {
      openEbayChannelBtn.show();
      loadEbayChannel.hide();
      closedBeforeAuth.show();
    }
  }

  function getAuthDateAndTime(){
    const date = new Date();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0'+minutes : minutes;
    const strTime = hours + ':' + minutes + ' ' + ampm;
    connAuth.text(getConnAuthText(date.toLocaleDateString(), strTime));
    connAuthDateTime.val(`${date.toLocaleDateString()},${strTime}`);
  }

  function getConnAuthText(date, time) {
    return `Connection authorized: ${date} at ${time} Click 'Next' to review and activate this channel.`;
  }

}



// WEBPACK FOOTER //
// ./src/pages/createChannel/ebayConnectionsTab.js